import cpConf from "./cps";
import cpZoneConf from "./cp_zones";

export default {
    id: "loc_id",
    key: "cp_loc",
    // edit_confirm: {
    //   enable: true,
    //   message: "message.sure_service_restart_required"
    // },
    fields: [
        {key: "loc_id", hidden: ["write"]},
        {key: "address"},
        {key: "address_chi"},
        {key: "provider_id", field: "provider_id.name_chi", value: "provider_id.provider_id", type: "select"},
        // { key: "mode_id", field: "mode_id.name_chi", value: "mode_id.payment_model_id", type: "select" },
        {key: "district_id", field: "district_id.name_chi", value: "district_id.district_id", type: "select"},
        {
            key: "lms_profile_id",
            field: "lms_profile_id.name",
            value: "lms_profile_id.lms_profile_id",
            type: "select",
            hidden: ["create"],
            privilege: ["READ_LMS_PROFILE"]
        },
        {key: "enable_flag", type: "boolean"},
        {key: "lupd_dttm", type: "datetime", hidden: ["write"]},
        // { key: "free_charge_flag", type: "boolean", hidden: ["list"] },
        {key: "mall_id"},
        {key: "station_code"},
        {key: "contact_number"},
        {key: "remark", row: 3, hidden: ["list"]},
        {key: "enable_lms", type: "boolean", privilege: ["READ_LMS_PROFILE"]},
        {key: "enable_reservation", type: "boolean"},
        {key: "payment_carpark_id", hidden: ["list"]},
        {key: "gps_lat"},
        {key: "gps_lng"},
        {type: "action-btn"}
    ],
    options: {
        provider_id: {
            key: "providers",
            label: "name_chi",
            value: "provider_id"
        },
        mode_id: {
            key: "payment_models",
            label: "name_chi",
            value: "payment_model_id"
        },
        district_id: {
            key: "districts",
            label: "name_chi",
            value: "district_id"
        },
        lms_profile_id: {
            key: "lms_profiles",
            label: "name",
            value: "lms_profile_id",
            params: ["loc_id"]
        }
    },
    structure: [
        ["provider_id", "district_id"],
        ["address"],
        ["address_chi"],
        ["address_chs"],
        ["gps_lat", "gps_lng"],

        ["mode_id", "rate_id"],
        ["min_charging_unit", "max_charging_unit"],
        ["default_charging_unit", "free_charge_flag"],

        ["postpaid_min_charge", "postpaid_max_charge"],
        ["postpaid_allowance_min"],
        ["lms_profile_id"],
        ["mall_id", "station_code"],
        ["payment_carpark_id"],
        ["contact_number"],
        ["remark"],
        // [""],
        ["enable_flag"],
        ["enable_lms"],
        ["enable_reservation"]
    ],
    view: [
        [{key: "provider_id", value: "provider_id.name_chi"}, {key: "district_id", value: "district_id.name_chi"}],
        ["address"],
        ["address_chi"],
        ["address_chs"],
        ["remark"],
        ["mall_id", "station_code"],
        ["gps_lat", "gps_lng"],
        [{key: "enable_flag", type: "boolean"}],
        [{key: "enable_lms", type: "boolean", privilege: ["READ_LMS_PROFILE"]}],
        ["enable_reservation"]
            // ["gps_lat","gps_lang"],

            // [{ key: "mode_id", value: "mode_id.name_chi" },"rate_id"],
            // ["min_charging_unit","max_charging_unit"],
            // ["default_charging_unit",{ key: "free_charge_flag", type: "boolean" }],

            // ["postpaid_min_charge","postpaid_max_charge"],
            // ["postpaid_allowance_min"],
            [{
            type: "tabs",
            items: [
                {
                    name: "cp",
                    params: ["loc_id"],
                    ...cpConf,
                    key: "cps",
                    fields: [
                        {key: "cp_id", width: 75},
                        {key: "cp_no", notfill: true},
                        {key: "name_chi"},
                        {key: "firmware_version", width: 95},
                        {key: "charging_status_code", field: "charging_status_code.name_chi", width: 100},
                        {key: "last_status_dttm", type: "datetime"},
                        {key: "boot_dttm", type: "datetime"},
                        {key: "lupd_dttm", type: "datetime"},
                        {key: "enable_flag", type: "boolean", width: 70},
                        {key: "freecharge_flag", type: "boolean"},
                        {type: "mass_update", width: 125},
                        {type: "action-btn", width: 50}
                    ]
                },
                {
                    name: "cp_zone",
                    params: ["loc_id"],
                    ...cpZoneConf,
                    key: "cp_zones",
                }
            ]
            , privilege: ["READ_LMS_PROFILE"],
        }]
    ],
    action: ["create", "edit", "view", "delete"]
}